import type { z } from 'zod'

import type { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'

import type {
  requestPurchaseModalLandingSchema,
  requestPurchaseModalSummarySchema,
} from './RequestPurchaseModal.schema'

export type RequestPurchaseModalLandingSchema = z.infer<
  typeof requestPurchaseModalLandingSchema
>

export type RequestPurchaseModalSummarySchema = z.infer<
  typeof requestPurchaseModalSummarySchema
>

export enum RequestPurchaseModalStepsEnum {
  'LANDING' = '1',
  'SUMMARY' = '2',
  'CONFIRMATION' = '5',
  'INVALID' = '10',
}

export interface RequestPurchaseModalStepsMap {
  [key: string]: {
    component: React.FunctionComponent<any>
    props: any
    title: string
  }
}

export interface RequestPurchaseModalProps {
  rental: getRental_rental
  onHide: () => void
}

export interface RequestPurchaseModalLandingProps {
  rental: getRental_rental
  onSetCurrentStep: (step: `${RequestPurchaseModalStepsEnum}`) => void
  onHide: () => void
}

export interface RequestPurchaseModalSummaryProps {
  rental: getRental_rental
  onSetCurrentStep: (
    step: `${RequestPurchaseModalStepsEnum}`,
    data?: RequestPurchaseModalSummarySchema,
  ) => void
  isSubmitting: boolean
}

export interface RequestPurchaseModalDeviceProps {
  rental: getRental_rental
}

export interface RequestPurchaseModalConfirmationProps {
  onHide: () => void
}

export interface RequestPurchaseModalInvalidProps {
  onHide: () => void
}
